import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { tableResponsiveStyles } from './styles/table-responsive.styles';
import type { TableResponsivePropsInterface } from './types/table-responsive.types';

/**
 * @since 8.0.0
 */
export const TableResponsive = forwardRef<HTMLDivElement, TableResponsivePropsInterface>(
  (props: TableResponsivePropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(tableResponsiveStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Table.Responsive"
        className={cx('c11n', 'c11n_table__responsive', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

TableResponsive.displayName = 'Table.Responsive';
